import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { filterAsyncRoutes } from '@/utils/index' // 👈 引入刚刚改造好的过滤方法

NProgress.configure({ showSpinner: false })
const whiteList = ['/login', '/404']
let hasAddAsyncRoutes = false

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = store.getters['user/token'] || localStorage.getItem('token')

  if (hasToken) {
    if (to.path === '/login') {
      next('/')
      NProgress.done()
    } else {
      if (!hasAddAsyncRoutes) {
        try {
          // 获取后端原生的树形路由数据
          const menuList = await store.dispatch('user/GetUserInfoAndMenu')
          // 转换为标准的组件路由对象
          const asyncRoutes = filterAsyncRoutes(menuList)

          // 👈 核心修改：由于顶级节点本身就是 Layout，直接作为根路由注入即可
          asyncRoutes.forEach((routeItem) => {
            router.addRoute(routeItem)
          })

          // 全局 404 兜底路由必须在最后面添加
          router.addRoute({ path: '*', redirect: '/404', hidden: true })

          hasAddAsyncRoutes = true
          next({ ...to, replace: true })
        } catch (error) {
          await store.dispatch('user/Logout')
          localStorage.removeItem('token')
          Message.error(error.message || '系统初始化路由失败')
          next(`/login?redirect=${to.path}`)
          hasAddAsyncRoutes = false
          NProgress.done()
        }
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

// 全局注册 v-hasPermi 权限指令
Vue.directive('hasPermi', {
  inserted(el, binding) {
    const requiredPerms = binding.value || []
    const userPerms = store.getters['user/permissions'] || []
    // 权限校验逻辑（根据您的实际需要放开）
    // const hasPermission = requiredPerms.some(perm => userPerms.includes(perm))
    // if (!hasPermission && el.parentNode) el.parentNode.removeChild(el)
  }
})